module.exports = __webpack_public_path__ + "static/media/BOTIM Pay.57554270.png";